import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {
  RichText,
  Field,
  ImageField,
  ImageFieldValue,
  NextImage,
  Text,
} from '@sitecore-jss/sitecore-jss-nextjs';
import {
  StHeader,
  StDescription,
  StContentItem,
  StContentListContainer,
  StIcon,
  StContent,
  StContentListContainerLaptop,
  StContentListSubContainer,
} from './FeatureHighlights.style';
import {
  StDTPGridContainer,
  StDTPWrapper,
} from '../../../components/shared/Container/Container.styles';
import UiText from '../../../components/shared/Typography/UiText';
import useApplyV2Theme from '../../../lib/hooks/useApplyV2Theme';

interface IFeatureHighlightItem {
  id: string;
  url: string;
  name: string;
  displayName: string;
  fields: {
    content: Field<string>;
  };
}
interface IFeatureHighlights {
  fields: {
    applyBackground?: Field<boolean>;
    contentList: Array<IFeatureHighlightItem> | [];
    description?: Field<string>;
    sectionIcon: ImageField;
    title: Field<string>;
  };
}
const FeatureHighlights = (props: IFeatureHighlights): JSX.Element => {
  const theme = useTheme();
  const isLaptopView = useMediaQuery(theme.breakpoints.up('lg'));
  const { isToapplyV2Theme } = useApplyV2Theme();
  if (!props?.fields) return <></>;

  return (
    <StDTPWrapper id="feature-highlights">
      <StDTPGridContainer>
        <StHeader>
          {isToapplyV2Theme ? (
            <UiText color="secondary" bold>
              {props?.fields?.title?.value}
            </UiText>
          ) : (
            <Text field={props?.fields?.title} />
          )}
        </StHeader>
        <StDescription>
          {isToapplyV2Theme ? (
            <UiText>
              <RichText field={props?.fields?.description} />
            </UiText>
          ) : (
            <RichText field={props?.fields?.description} />
          )}
        </StDescription>
        <>
          {isLaptopView ? (
            <>
              <StContentListContainerLaptop>
                <StContentListSubContainer>
                  {props?.fields?.contentList
                    .filter((_, i) => !(i % 2))
                    .map((item) => {
                      return (
                        <StContentItem
                          key={item.id}
                          applyBackground={props?.fields?.applyBackground?.value}
                        >
                          {props?.fields?.applyBackground?.value && (
                            <StIcon>
                              <NextImage field={props?.fields?.sectionIcon as ImageFieldValue} />
                            </StIcon>
                          )}
                          <StContent>
                            {isToapplyV2Theme ? (
                              <UiText>{item?.fields?.content?.value}</UiText>
                            ) : (
                              <RichText field={item?.fields?.content} />
                            )}
                          </StContent>
                        </StContentItem>
                      );
                    })}
                </StContentListSubContainer>
                <StContentListSubContainer>
                  {props?.fields?.contentList
                    .filter((_, i) => i % 2)
                    .map((item) => {
                      return (
                        <StContentItem
                          key={item.id}
                          applyBackground={props?.fields?.applyBackground?.value}
                        >
                          {props?.fields?.applyBackground?.value && (
                            <StIcon>
                              <NextImage field={props?.fields?.sectionIcon as ImageFieldValue} />
                            </StIcon>
                          )}
                          <StContent>
                            {isToapplyV2Theme ? (
                              <UiText>{item?.fields?.content?.value}</UiText>
                            ) : (
                              <RichText field={item?.fields?.content} />
                            )}
                          </StContent>
                        </StContentItem>
                      );
                    })}
                </StContentListSubContainer>
              </StContentListContainerLaptop>
            </>
          ) : (
            <>
              <StContentListContainer>
                {props?.fields?.contentList.map((item) => {
                  return (
                    <StContentItem
                      key={item.id}
                      applyBackground={props?.fields?.applyBackground?.value}
                    >
                      {props?.fields?.applyBackground?.value && (
                        <StIcon>
                          <NextImage field={props?.fields?.sectionIcon as ImageFieldValue} />
                        </StIcon>
                      )}
                      <StContent>
                        {isToapplyV2Theme ? (
                          <UiText>{item?.fields?.content?.value}</UiText>
                        ) : (
                          <RichText field={item?.fields?.content} />
                        )}
                      </StContent>
                    </StContentItem>
                  );
                })}
              </StContentListContainer>
            </>
          )}
        </>
      </StDTPGridContainer>
    </StDTPWrapper>
  );
};

export default FeatureHighlights;
